export default __webpack_public_path__ + "static/hero1-fd0e8100911b20995690e7196a8d182d.webp";